import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import { trackEvent } from '../lib/fbpixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  fullWidth?: boolean;
  onClick?: () => void;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  onClick,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-oswald uppercase tracking-wider font-bold transition-colors duration-200 overflow-hidden group';
  const variants = {
    primary: 'bg-tactical-cta hover:bg-tactical-ctaHover text-zinc-950 px-8 py-4 text-lg sm:text-xl shadow-[0_0_20px_rgba(245,158,11,0.3)]',
    outline: 'bg-transparent border-2 border-tactical-accent text-tactical-accent hover:bg-tactical-accent/10 px-6 py-3 text-base'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = () => {
    trackEvent('AddToCart', {
      content_name: 'Protocolo Actuar es Ganar',
      currency: 'USD',
      value: 6.39
    });
    const checkoutUrl = 'https://actuandoya.com/cart/49388386123943:1';
    const newWindow = window.open(checkoutUrl, '_blank', 'noopener,noreferrer');
    // Fallback if popups are blocked (e.g. inside a sandboxed iframe)
    if (!newWindow) {
      try {
        const top = window.top;
        if (top) {
          top.location.href = checkoutUrl;
        } else {
          window.location.href = checkoutUrl;
        }
      } catch (e) {
        window.location.href = checkoutUrl;
      }
    }
    if (onClick) onClick();
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} onClick={handleClick} {...props} data-id="element-14">
      {/* Tactical corner accents */}
      <span className="absolute top-0 left-0 w-2 h-2 border-t-2 border-l-2 border-current opacity-50" data-id="element-15"></span>
      <span className="absolute bottom-0 right-0 w-2 h-2 border-b-2 border-r-2 border-current opacity-50" data-id="element-16"></span>

      <span className="relative z-10 flex items-center gap-2" data-id="element-17">
        {children}
        {variant === 'primary' && <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-18" />}
      </span>
    </motion.button>;
}